/**
 * Fach-Entitäten des Politik-Portals (read-only, befüllt via Sync-Adapter).
 *
 * Das Modell ist inhaltlich am OParl-1.1-Modell orientiert (weil das die
 * fachliche Realität von Gremienarbeit gut abbildet), aber es ist das EIGENE
 * Modell der App — die SPA kennt nie ein Quellformat direkt. IDs sind eigene
 * IDs; die Original-URL/ID der Quelle steht in `sourceRef` (Provenance).
 */
// =============================================================================
// Enums
// =============================================================================
export var MeetingStatus;
(function (MeetingStatus) {
    MeetingStatus["GEPLANT"] = "geplant";
    MeetingStatus["DURCHGEFUEHRT"] = "durchgefuehrt";
    MeetingStatus["ABGESAGT"] = "abgesagt";
})(MeetingStatus || (MeetingStatus = {}));
export var PaperType;
(function (PaperType) {
    PaperType["ANTRAG"] = "antrag";
    PaperType["ANFRAGE"] = "anfrage";
    PaperType["VORLAGE"] = "vorlage";
    PaperType["SONSTIGES"] = "sonstiges";
})(PaperType || (PaperType = {}));
export var OrganizationType;
(function (OrganizationType) {
    OrganizationType["RAT"] = "rat";
    OrganizationType["AUSSCHUSS"] = "ausschuss";
    OrganizationType["BEZIRKSVERTRETUNG"] = "bezirksvertretung";
    OrganizationType["FRAKTION"] = "fraktion";
    OrganizationType["SONSTIGES"] = "sonstiges";
})(OrganizationType || (OrganizationType = {}));
// =============================================================================
// Call-Shapes (read-only: list/detail je Objekt)
// =============================================================================
export const MEETING_OBJECT = "meeting";
export const PAPER_OBJECT = "paper";
export const ORGANIZATION_OBJECT = "organization";
export const PERSON_OBJECT = "person";
// -----------------------------------------------------------------------------
// Beratungen (Stationen einer Drucksache)
// -----------------------------------------------------------------------------
export const BERATUNG_OBJECT = "beratung";
//# sourceMappingURL=ris-model.js.map